import { client } from "@/http/client"

import { IPagingResponse, IRequestParams, IResponse } from "@/types/api"
import { IFinanceReturnFunds, IFinanceReturnFundsCreate, IReturnChangeStatus } from "@/types/IFinanceReturnFunds"

export const getFinanceReturns = (params: IRequestParams): Promise<IPagingResponse<IFinanceReturnFunds>> =>
  client.get("/FinanceReturnFunds", {
    params
  })
export const getFinanceReturnById = (id: number): Promise<IResponse<IFinanceReturnFunds>> =>
  client.get(`/FinanceReturnFunds/${id}`)

  export const createFinanceReturnFunds = (
  body: IFinanceReturnFundsCreate
): Promise<IResponse<number>> => client.post("/FinanceReturnFunds", body)

  export const createCustomerFinanceReturnFunds = (
  body: IFinanceReturnFundsCreate
): Promise<IResponse<number>> => client.post("/FinanceReturnFunds/customer", body)


export const changeReturnStatus = (
  body: IReturnChangeStatus
): Promise<IResponse<boolean>> => client.patch("/FinanceReturnFunds/change-status/customer", body)

export const changeReturnStatusByAdmin = (
  body: IReturnChangeStatus
): Promise<IResponse<boolean>> => client.patch("/FinanceReturnFunds/change-status", body)